import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Stack,SearchBox, Text,Dropdown,DatePicker,IDatePickerStrings,Shimmer} from '@fluentui/react';
import { IconButton } from '@fluentui/react/lib/Button';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { useMyContext } from "../../../context/myContext";
import * as Constants from "../../../utils/constants";
import {
  ServiceContext,
} from "@msx/platform-services";
import { getConsumptionAPI } from "../../../utils/httpUtils";
import "./TicketDetails.css";
import { useDispatch } from "react-redux";
import {
  SETChileComponentName,
  SETHasServiceRequestTypeLogData,
  SETIsCustomeLog,
  SETLogEventData,
  SETServiceRequestTypeLogData,
} from "../../../../core/store";
import { lazyRetry } from '../../../utils/utils';

const NewUITicketDetails = lazy(() => lazyRetry(() => import("./NewUI_TicketDetails")));
const StatusTile = lazy(() => lazyRetry(() => import("./StatusTile")));

export interface TicketDetailsProp extends InjectedIntlProps {
  userId: any;
  isUserLoggedIn: any;
  setActiveTabKey?: any;
  setIsTicketDetailVisible: any;
  status: any;
}

const NewUITicketDetailsComponent: React.FC<TicketDetailsProp> = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [closedTicketCount, setClosedTicketCount] = useState(0);
  const [activeTicketCount, setActiveTicketCount] = useState(0);

  const context = React.useContext(ServiceContext);

  const [ data, updateContextData ] = useState([]);

  const [status, setStatus] = useState(props.status);
  const [createdOn, setCreatedOn] = useState(null);
  const [targetSystem, setTargetSystem] = useState("");
  const [optionsTargetSystems, setOptionsTargetSystems] = useState([]);
  const [optionsStatus, setOptionsStatus] = useState([]);

  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [searchText, setSearchText] = useState("");

  const maxDate = new Date();
  const reduxDispatch = useDispatch();

  const formatDate: IDatePickerStrings = {
    shortMonths: [
      "01",
      "02",
      "03",
      "04",
      "05",
      "06",
      "07",
      "08",
      "09",
      "10",
      "11",
      "12",
    ],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    shortDays: ["S", "M", "T", "W", "T", "F", "S"],
    days: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ],
    goToToday: "Go to today",
    prevMonthAriaLabel: "Go to previous month",
    nextMonthAriaLabel: "Go to next month",
    prevYearAriaLabel: "Go to previous year",
    nextYearAriaLabel: "Go to next year",
    closeButtonAriaLabel: "Close date picker",
  };

  const formatSelectedDate = (date: Date | null): string => {
    if (!date) {
      return "";
    }

    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(2);

    return `${month}/${day}/${year}`;
  };

  // useEffect(() => {
  //   reduxDispatch(SETChileComponentName("My Help Dashboard"));
  //   reduxDispatch(SETHasServiceRequestTypeLogData(true));
  //   reduxDispatch(
  //     SETLogEventData({
  //       elementName: "My Help Dashboard ",
  //       elementId: "",
  //       action: "Click",
  //       message: `User open  My Help Dashboard page `,
  //     })
  //   );
  //   reduxDispatch(SETIsCustomeLog(true));
  //   const getWorkspaceData = async () => {
  //     try {
  //       if (context?.telemetryClient) {
  //           const responseServiceWorkspace = await getConsumptionAPI(
  //             `/api/Support/GetMySupportRequests`,
  //             context.authClient
  //           );
  //           if (responseServiceWorkspace?.data) {
  //             checkDataResponse(responseServiceWorkspace);             
  //           } else {
  //             throw new Error("Failed to fetch data.");
  //           }
  //       }
  //     } catch (error) {
  //       console.error("An error occurred while fetching data.", error);
  //     } finally {
  //       setLoading(false); // Set loading to false regardless of success or error
  //     }
  //   };
  //   if (props.isUserLoggedIn) {
  //     getWorkspaceData();
  //   }
  // }, [props.isUserLoggedIn]);

  // const checkDataResponse = (responseServiceWorkspace) => {
  //   let result = checkResponse(responseServiceWorkspace);
  //   if (result === "success") {
  //     let responseValue = responseServiceWorkspace.data.content.value;
  //     bindStatus(responseValue);
  //     bindTargetSystem(responseValue);
  //     calculateDataForTicket(responseValue);
  //    updateContextData(responseValue);
  //   }
  // };

  // const bindStatus = (data) => {
  //   let itemStatus = [{ key: "All", text: "All", value: "All" }];

  //   data.forEach((e) => {
  //     const lowerItemStatus = e.status.toLowerCase();
  //     const itemStatusExist = itemStatus.some(
  //       (item) => item.key.toLowerCase() === lowerItemStatus
  //     );
  //     if (!itemStatusExist) {
  //       itemStatus.push({ key: e.status, text: e.status, value: e.status });
  //     }
  //   });

  //   setOptionsStatus(itemStatus);
  // };

  // const bindTargetSystem = (data) => {
  //   let targetsystems = [{ key: "", text: "All", value: "" }];

  //   data.forEach((e) => {
  //     const lowercaseTargetSystem = e.targetSystem.toLowerCase();
  //     const targetSystemExists = targetsystems.some(
  //       (item) => item.key.toLowerCase() === lowercaseTargetSystem
  //     );
  //     if (!targetSystemExists) {
  //       targetsystems.push({
  //         key: e.targetSystem,
  //         text: e.targetSystem,
  //         value: e.targetSystem,
  //       });
  //     }
  //   });

  //   setOptionsTargetSystems(targetsystems);
  // };

  // const checkResponse = (response) => {
  //   switch (response.status) {
  //     case 200:
  //       if (typeof response.data.content.value === "object") {
  //         return "success";
  //       } else if (
  //         response.data.content.value === "Error from Azure Function: Not Found"
  //       ) {
  //         setActiveTicketCount(0);
  //         setClosedTicketCount(0);

  //         return "successFromValue";
  //       } else {
  //         return "errorFromValue";
  //       }
  //     case 201:
  //     case 204:
  //       return "success";
  //     case 401:
  //     default:
  //       return "error";
  //   }
  // };

  // const calculateDataForTicket = (data) => {
  //   data.length > 0 &&
  //     data.map((e) => {
  //       if (
  //         e.status === "Closed" ||
  //         (e.targetSystem.toLowerCase() === "hrd365" &&
  //           e.status.toLowerCase() === "resolved") ||
  //         (e.targetSystem.toLowerCase() === "uatracker" &&
  //           e.status.toLowerCase() === "done")
  //       ) {
  //         setClosedTicketCount((prevCount) => prevCount + 1);
  //       } else {
  //         setActiveTicketCount((prevCount) => prevCount + 1);
  //       }
  //     });
  // };

  // const gotoMyWorkspace = () => {
  //   reduxDispatch(SETChileComponentName("My Help Dashboard"));
  //   reduxDispatch(SETHasServiceRequestTypeLogData(true));
  //   reduxDispatch(
  //     SETLogEventData({
  //       elementName: "My Help Dashboard back",
  //       elementId: "",
  //       action: "Click",
  //       message: `User click on back button of My Help Dashboard page`,
  //     })
  //   );
  //   reduxDispatch(SETIsCustomeLog(true));
  //   props.setIsTicketDetailVisible(false);
  // };

   const handleClearFilter = () => {
  //   reduxDispatch(SETChileComponentName("My Help Dashboard"));
  //   reduxDispatch(SETHasServiceRequestTypeLogData(true));
  //   reduxDispatch(
  //     SETLogEventData({
  //       elementName: "My Help Dashboard Clear Filter",
  //       elementId: "",
  //       action: "Click",
  //       message: `User Clear Filter  on My Help Dashboard page `,
  //     })
  //   );
  //   reduxDispatch(SETIsCustomeLog(true));
    setStatus("All");
    setCreatedOn(null);
    setTargetSystem("");
    setSearchText("");
   };

   const handleStatusChange = (event, option) => {
  //   reduxDispatch(SETChileComponentName("My Help Dashboard"));
  //   reduxDispatch(SETHasServiceRequestTypeLogData(true));
  //   reduxDispatch(
  //     SETLogEventData({
  //       elementName: "My Help Dashboard Status change",
  //       elementId: "",
  //       action: "on Change",
  //       message: `User Status change  on My Help Dashboard page `,
  //     })
  //   );
  //   reduxDispatch(SETIsCustomeLog(true));
    setStatus(option.value);
   };

   const handleTrackingSystemChange = (event, option) => {
  //   reduxDispatch(SETChileComponentName("My Help Dashboard"));
  //   reduxDispatch(SETHasServiceRequestTypeLogData(true));
  //   reduxDispatch(
  //     SETLogEventData({
  //       elementName: "My Help Dashboard Tracking System Change",
  //       elementId: "",
  //       action: "on Change",
  //       message: `User Tracking System Change on My Help Dashboard page `,
  //     })
  //   );
  //   reduxDispatch(SETIsCustomeLog(true));
     setTargetSystem(option.value);
   };

  const handleDateChange = (date: Date | null | undefined): void => {
    // reduxDispatch(SETChileComponentName("My Help Dashboard"));
    // reduxDispatch(SETHasServiceRequestTypeLogData(true));
    // reduxDispatch(
    //   SETLogEventData({
    //     elementName: "My Help Dashboard Date Search",
    //     elementId: "",
    //     action: "on DateChange",
    //     message: `User Date Search  on My Help Dashboard page `,
    //   })
    // );
    // reduxDispatch(SETIsCustomeLog(true));
     setCreatedOn(date || null); // Ensure null if undefined
  };
  const handleClearSearch = () => {
    //reduxDispatch(SETChileComponentName("My Help Dashboard"));
    setSearchText("");
  };
   const handleSearhText = (searchtext) => {
  //   reduxDispatch(SETChileComponentName("My Help Dashboard"));
  //   reduxDispatch(SETHasServiceRequestTypeLogData(true));
  //   reduxDispatch(
  //     SETLogEventData({
  //       elementName: "My Help Dashboard Search",
  //       elementId: "",
  //       action: "on Change",
  //       message: `User Search  on My Help Dashboard page `,
  //     })
  //   );
  //   reduxDispatch(
  //     SETServiceRequestTypeLogData({
  //       SearchTerm: searchtext?.target?.value,
  //     })
  //   );
  //   reduxDispatch(SETIsCustomeLog(true));
    if (searchtext) {
      setSearchText(searchtext.target.value);
    } else {
      setSearchText("");
    }
  };
  const getTicketsCountFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const ticketCount= parseInt(urlParams.get("ticketsCount") || "2", 10); // Default to 5 if not present
    return ticketCount;
  };
  const activeTickets=getTicketsCountFromUrl();
  return (
    <>
      <div style={{ display: 'flex',width: '77%', marginLeft: '24px', alignItems: 'flex-start' }}>
        
        {/* Left Section (Ticket Count) */}
        <div style={{ width: '40%', display: 'flex', flexDirection: 'column',paddingLeft:'5%',paddingTop:'2%' }}>
          <h3 className="dashboard-heading">My Help Tickets</h3>
  
          <div>
            {isLoading ? (
              <Stack horizontal styles={{ root: { width: "200px", height: 89 } }}>
                <Shimmer width={200} height={89} />
              </Stack>
            ) : (
              <Suspense fallback={<></>}>
                <StatusTile status="Open" count={activeTickets} iconName="CircleRing" />
              </Suspense>
            )}
          </div>
  
          <div>
            {isLoading ? (
              <Stack horizontal styles={{ root: { width: "200px", height: 89 } }}>
                <Shimmer width={200} height={89} />
              </Stack>
            ) : (
              <Suspense fallback={<></>}>
                <StatusTile status="Closed" count={closedTicketCount} iconName="Completed" />
              </Suspense>
            )}
          </div>
        </div>
  
        {/* Right Section (NewUITicketDetails) */}
        <div style={{ width: '75%', display: 'flex', flexDirection: 'column' }}>
          {isLoading ? (
            <Stack horizontal styles={{ root: { width: "100%", height: 20 } }}>
              <Shimmer width={1000} height={20} />
            </Stack>
          ) : (
            <Stack
              horizontal
              verticalAlign="center"
              horizontalAlign="space-between"
              tokens={{ childrenGap: 10 }}
              styles={{ root: { margin: "10px 0px", width: "70%" } }}>
              {/* <span
                style={{
                  textAlign: "left",
                  fontSize: "10px",
                  fontWeight: "bolder",
                  fontStyle: "italic",
                }}>
                {Constants.TICKET_ESCALATION_MESSAGE}
              </span> */}
  
              <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                <div className="search-box">
                  <SearchBox
                    placeholder="Search..."
                    value={searchText}
                    onChange={handleSearhText}
                    aria-label="Search Box"
                    onClear={handleClearSearch}
                  />
                </div>
                <div
                  className="filter-button-section"
                  onClick={() => setIsFilterVisible(!isFilterVisible)}>
                  <IconButton
                    iconProps={{ iconName: "Filter" }}
                    title="Filter"
                    ariaLabel="Filter"
                  />
                  <Text variant="medium">Filter</Text>
                </div>
              </div>
            </Stack>
          )}
  
          {/* Filter Section */}
          {isFilterVisible && (
            <div className="filter-section">
              <div className="filter-dropdown-container">
                <Text className="filter-label" variant="smallPlus">Status</Text>
                <Dropdown
                  options={optionsStatus}
                  onChange={handleStatusChange}
                  placeholder="Select Status"
                  className="filter-dropdown"
                  selectedKey={status}
                  aria-label="Status Dropdown"
                />
              </div>
              <div className="filter-dropdown-container filter-date-container">
                <Text className="filter-label" variant="smallPlus">Created On</Text>
                <DatePicker
                  value={createdOn}
                  onSelectDate={handleDateChange}
                  placeholder="Select Created On"
                  className="filter-dropdown"
                  formatDate={(date) => formatSelectedDate(date)}
                  strings={formatDate}
                  maxDate={maxDate}
                  aria-label="Date Picker"
                />
              </div>
              <div className="filter-dropdown-container">
                <Text className="filter-label" variant="smallPlus">Target System</Text>
                <Dropdown
                  options={optionsTargetSystems}
                  onChange={handleTrackingSystemChange}
                  placeholder="Select Target System"
                  className="filter-dropdown"
                  selectedKey={targetSystem}
                  aria-label="Target System Dropdown"
                />
              </div>
  
              <div
                className="clear-filter"
                onClick={handleClearFilter}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    handleClearFilter();
                  }
                }}
                tabIndex={0}
                role="button"
                aria-label="Clear All Filter"
              >
                <span className="clear-filter-text">Clear All</span>
              </div>
            </div>
          )}
  
          {isLoading ? (
            <Stack horizontal styles={{ root: { width: "100%", height: "100%" } }}>
              <Shimmer width={1000} height={800} />
            </Stack>
          ) : (
            <Suspense fallback={<></>}>
              <NewUITicketDetails
                data={data}
                status={"All"}
                targetSystem={targetSystem}
                createdOn={createdOn}
                searchText={searchText}
              />
            </Suspense>
          )}
        </div>
      </div>
    </>
  );
};

export const NewUITicketDetailPage = injectIntl(NewUITicketDetailsComponent);
